// 黑吃瓜首页静态数据源
// 说明：以下内容均为虚构演绎的娱乐／网红／社会题材示例，仅用于静态展示页面结构。

export const tickerItems = [
  { time: '00:47', text: '某千万粉情感主播被曝账号实为 MCN 共管，深夜人设剧本片段疑流出' },
  { time: '00:18', text: '选秀综艺回锅选手团队前经纪人开麦，爆出 4 年前换票内幕与聊天截图' },
  { time: '23:52', text: '头部美妆主播双十一备货合同现阴阳条款，供应商联名索要差额曝光' },
  { time: '23:31', text: '剧组副导演晒通告单，疑似某顶流档期排满实为替身补拍引发围观' },
  { time: '22:58', text: '饭圈反黑站倒戈放锤，偶像恋情站姐内部投票结果被逐页晒出' },
  { time: '22:26', text: '探店博主同一门店重复评分被抓包，平台结算后台数据流出存疑' },
];

export const entryChannels = [
  {
    key: 'wanghong',
    icon: 'ri-user-star-line',
    name: '网红圈',
    count: 7,
    state: '爆发中',
    tagline: '头部主播人设翻车与 MCN 争议集中区',
  },
  {
    key: 'yule',
    icon: 'ri-mic-line',
    name: '娱乐瓜田',
    count: 5,
    state: '高热度',
    tagline: '剧组内幕、商务塌房与作品抢番的瓜',
  },
  {
    key: 'shehui',
    icon: 'ri-bank-line',
    name: '社会热闻',
    count: 3,
    state: '讨论中',
    tagline: '素人事件被拱上热搜后的完整时间线',
  },
  {
    key: 'muhou',
    icon: 'ri-coin-line',
    name: '幕后资本',
    count: 2,
    state: '深挖中',
    tagline: '明星周边公司与股权代持的暗线',
  },
  {
    key: 'fanquan',
    icon: 'ri-heart-3-line',
    name: '饭圈观察',
    count: 6,
    state: '追更中',
    tagline: '应援账目、站姐内讧与反黑互锤',
  },
  {
    key: 'fanche',
    icon: 'ri-arrow-down-double-line',
    name: '翻车录',
    count: 9,
    state: '最热闹',
    tagline: '从一句话到全网塌房的高赞复盘',
  },
];

export const freshItems = [
  {
    id: 'f1',
    circle: '网红圈',
    tag: '人设崩塌',
    badge: '今日最猛',
    title: '「清醒恋爱观」男主播被曝三年前注册情感课程割韭菜，连讲稿都是同一批学员投稿',
    summary:
      '凌晨该主播以“只有你看不懂的瓜才是真瓜”回应，评论区站姐晒出其早期连麦录音，疑似亲口承认脚本由运营代写，粉丝量一小时掉粉近两万。',
    time: '00:47',
    comment: 482,
    heat: 96100,
    level: 3,
    thumb:
      'https://readdy.ai/api/search-image?query=Editorial%20abstract%20collage%20of%20torn%20newspaper%20paper%20with%20bold%20red%20and%20coral%20ink%20splashes%2C%20a%20single%20phone%20silhouette%20with%20a%20breaking%20news%20icon%2C%20warm%20cream%20paper%20background%2C%20minimal%2C%20high%20contrast%2C%20artistic%20gossip%20media%20vibe&width=640&height=440&seq=fresh-gua-01&orientation=landscape',
  },
  {
    id: 'f2',
    circle: '娱乐瓜田',
    tag: '商务塌房',
    badge: '新料',
    title: '剧组被曝资金吃紧，主演片酬走个人账户，配角三个月没结尾款',
    summary:
      '制作方深夜发声明称系“审计流程”，但副导演已删除此前“工资早发”动态，知情配的工资条截图成为在场证据。',
    time: '23:52',
    comment: 317,
    heat: 74200,
    level: 2,
    thumb:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20clapperboard%20and%20film%20reels%20drawn%20in%20minimal%20line%20art%20with%20warm%20orange%20and%20deep%20red%20accents%20on%20soft%20cream%20paper%2C%20document%20stamps%20and%20signatures%20scattered%2C%20clean%20composition&width=640&height=440&seq=fresh-gua-02&orientation=landscape',
  },
  {
    id: 'f3',
    circle: '社会热闻',
    tag: '时间线',
    badge: '反转',
    title: '博主摆拍“深夜助人”翻车：当事路人辟谣，公益人设一年前就已埋雷',
    summary:
      '从道歉声明到删除置顶，再到合作方解约，全程不到十小时。我们按小时拉出完整节点，避免你在评论区只看一半。',
    time: '22:58',
    comment: 291,
    heat: 68800,
    level: 2,
    thumb:
      'https://readdy.ai/api/search-image?query=Minimal%20editorial%20paper%20collage%20with%20a%20mountain%20of%20folded%20newspapers%2C%20a%20single%20searchlight%20beam%20and%20question%20mark%2C%20warm%20amber%20and%20ink%20brown%20tones%2C%20soft%20cream%20background%2C%20clean%20artistic%20media%20style&width=640&height=440&seq=fresh-gua-03&orientation=landscape',
  },
];

export const ranking = [
  { rank: 1, title: '清醒恋爱观男主播 1 小时掉粉两万', circle: '网红圈', heat: 96100, delta: '+128%', up: true, icon: 'ri-fire-line' },
  { rank: 2, title: '选秀回锅选手换票内幕持续发酵', circle: '娱乐瓜田', heat: 87900, delta: '+93%', up: true, icon: 'ri-file-search-line' },
  { rank: 3, title: '美妆主播双十一阴阳合同引供应商联名', circle: '网红圈', heat: 82100, delta: '+76%', up: true, icon: 'ri-file-list-line' },
  { rank: 4, title: '“深夜助人”博主公益人设塌房', circle: '社会热闻', heat: 68800, delta: '+41%', up: true, icon: 'ri-question-line' },
  { rank: 5, title: '顶流档期替身补拍通告单真假之争', circle: '娱乐瓜田', heat: 55300, delta: '-12%', up: false, icon: 'ri-time-line' },
  { rank: 6, title: '饭圈应援账目公开被指对不上', circle: '饭圈观察', heat: 44200, delta: '+25%', up: true, icon: 'ri-calculator-line' },
];

export const hotWords = [
  { word: '恋爱导师剧本', strength: 96 },
  { word: '换票内幕', strength: 88 },
  { word: '阴阳合同', strength: 82 },
  { word: '公益人设', strength: 74 },
  { word: '替身补拍', strength: 66 },
  { word: '应援账目', strength: 58 },
];

export const topicCards = [
  {
    id: 't1',
    size: 'lg',
    circle: '连续剧',
    title: '一部“从塌房到和解”的高能连续瓜，本站已连载 6 集',
    desc: '从一张模糊聊天截图开始，到当事人深夜直播认错、再到隔天反转——把每个节点、每次声明都按顺序收进同一时间线，追更不再漏看中间集。',
    chapters: '第 6 集 · 昨夜 00:47 更新',
    time: '02 小时前',
    heat: 96100,
  },
  {
    id: 't2',
    size: 'sm',
    circle: '深扒',
    title: '某童星转型电商，公司注册地址三年换五次',
    desc: '注册资本、法人变更与商标抢注的暗线，一篇讲清。',
    time: '04 小时前',
    heat: 41200,
  },
  {
    id: 't3',
    size: 'sm',
    circle: '辟谣',
    title: '“退出娱乐圈”虚晃一枪，隔周新剧照流出',
    desc: '粉丝激情复读的评论区，这次恐怕要翻篇了。',
    time: '06 小时前',
    heat: 35500,
  },
  {
    id: 't4',
    size: 'sm',
    circle: '比价',
    title: '两位顶流商务报价单对比，同一档位价差惊人',
    desc: '带话题的广告主视角复盘，看谁在挤水分。',
    time: '09 小时前',
    heat: 33400,
  },
  {
    id: 't5',
    size: 'lg',
    circle: '反转',
    title: '被骂上热搜的“恋爱脑劝分帖”，最后竟是营销号自导自演',
    desc: '从登顶热搜到原帖消失，再到脚本作者主动认领，全程高潮。我们把双方说法并排摆出，留给你自己判断哪边更站得住。',
    chapters: '补充锤 · 昨夜更新',
    time: '11 小时前',
    heat: 51800,
  },
];

export const pending = [
  { title: '某综艺素人嘉宾被爆有主播背景，下周或迎大瓜', eta: '预计 24h 内', clue: '已有两张后台截图外传', tag: '待认领' },
  { title: '头部直播间“专场优惠”被指与商场同价，晚间或有回应', eta: '预计 48h 内', clue: '比价达人已备好证据链', tag: '在蹲' },
  { title: '剧组片酬纠纷后，传闻有人要放出完整录音', eta: '待确认', clue: '内部已开始放风', tag: '围观' },
];

export const todayMeta = {
  count: 18,
  peak: '22:30 前后',
};